// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__GXnTY","contentWrapper":"styles_contentWrapper__d1aYp","content":"styles_content__gu0f7"};